import { cn } from 'lib/utils'
import { ElementType, forwardRef } from 'react'

export interface SkeletonProps extends React.HTMLAttributes<HTMLElement> {
  as?: ElementType
  isLoaded?: boolean
}

export const Skeleton = forwardRef<HTMLElement, SkeletonProps>((props, ref) => {
  const { as: Comp = 'div', isLoaded, className, children, ...rest } = props

  if (isLoaded) {
    return (
      <Comp ref={ref} className={cn('animate-in fade-in', className)} {...rest}>
        {children}
      </Comp>
    )
  }

  return (
    <Comp ref={ref} className={cn('animate-pulse rounded-md bg-zinc-200', className)} data-skeleton {...rest}>
      <div className='invisible'>{children}</div>
    </Comp>
  )
})

Skeleton.displayName = 'Skeleton'
